import axios from './interceptor';

const SEARCH_URL = `${process.env.REACT_APP_BASE_URL}/search`;

export const globalSearch = async (query) => {
  try {
    const response = await axios.get(`${SEARCH_URL}/global`, {
      params: { q: query }
    });
    
    if (response.data.success) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Global search error:", error);
    return [];
  }
};
